import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import isEqual from 'lodash/isEqual'
import { postalCode } from 'utils/format'
import { ADDRESS } from 'constants/objects/address'
import { Edit } from '@material-ui/icons'
import { AddressForm } from 'components/Customer/AddressForm'
import { SlideDialog } from 'ui-components/SlideDialog'
import { Card } from 'ui-components/Card'
import { CardTitle } from 'ui-components/CardTitle'
import { DescItemInfo } from 'ui-components/DescItemInfo'
import { Address, EditButton } from './styles'

export default function AddressInfo(props) {
  const {
    addresses,
    saving,
    responseError,
    onSave,
  } = props

  const [toEdit, setToEdit] = useState(false)
  const [saved, setSaved] = useState(true)

  useEffect(() => {
    setToEdit(!saved)
  }, [saved])

  useEffect(() => {
    setSaved(!saving)
  }, [saving])

  const renderCityAndState = (address) => {
    const city = address.city?.name || ''
    const state = address.state?.abbr || ''
    return `${city}${city && state ? ' - ' : ''}${state}`
  }

  const renderAddressAndNumber = (customerAddress) => {
    const { address, number } = customerAddress
    return `${address}${address && number ? ' - ' : ''}${number}`
  }

  const renderAddress = (address, index) => (
    <DescItemInfo
      key={`address-${index}`}
      label={address.description || 'Endereço'}
    >
      <Address>
        <div>
          <div>
            {renderAddressAndNumber(address)}
          </div>
          <div>
            {address.district}
          </div>
          <div>
            {renderCityAndState(address)}
          </div>
          <p>
            {postalCode(address.postal_code)}
          </p>
        </div>
        <EditButton
          buttonType="icon"
          onClick={() => setToEdit(true)}
        >
          <Edit />
        </EditButton>
      </Address>
    </DescItemInfo>
  )

  const renderAddresses = () => {
    if (!addresses.length || isEqual(addresses[0], ADDRESS)) {
      return (
        <Address>
          <DescItemInfo label="Endereço">
            Nenhum endereço registrado
          </DescItemInfo>
          <EditButton
            buttonType="icon"
            onClick={() => setToEdit(true)}
          >
            <Edit />
          </EditButton>
        </Address>
      )
    }

    return addresses.map((item, index) => renderAddress(item, index))
  }

  return (
    <Card>
      <SlideDialog
        open={toEdit}
        onClose={() => setToEdit(false)}
      >
        <AddressForm
          address={addresses[0]}
          onCancel={() => setToEdit(false)}
          onSave={onSave}
          responseError={responseError}
          saving={saving}
        />
      </SlideDialog>
      <CardTitle title="Endereços" noMargin />

      {renderAddresses()}

    </Card>
  )
}

AddressInfo.propTypes = {
  addresses: PropTypes.arrayOf(PropTypes.object),
  saving: PropTypes.bool,
  responseError: PropTypes.objectOf(PropTypes.any),
  onSave: PropTypes.func.isRequired,
}

AddressInfo.defaultProps = {
  addresses: [],
  saving: false,
  responseError: null,
}
